var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon",class:{ coupon_active: _vm.active, coupon_small: _vm.type === 'small' }},[_c('span',{staticClass:"coupon__text"},[_vm._v(_vm._s(_vm.text))]),(_vm.active)?_c('div',{staticClass:"coupon__icon",on:{"click":_vm.copyText}},[_c('DSIcon',{attrs:{"icon":"copy","color":"linked","dise":"s"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }